import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import Swal from "sweetalert2";
import { CriarNovaSenhaController } from "../../../Controllers/Login/LoginController";

interface RecoveryFormInterface {
    SenhaNova: "string";
    cPassword: "string";
}

interface URLParams {
    token: string;
}


export function RecoveryForm() {

    const { token }: URLParams = useParams();
    const history = useHistory();

    const { register, handleSubmit, formState, setError } = useForm();

    function handleFormSubmit(formData: RecoveryFormInterface) {
        if (formData.SenhaNova !== formData.cPassword) {
            setError("cPassword", {
                message: "Senhas não correspondem",
            });
        } else {
            CriarNovaSenhaController(formData.SenhaNova, token).then((res) => {
                Swal.fire({
                    title: "Senha alterada com sucesso!",
                    icon: "success",
                    customClass: {
                        confirmButton: "d-none",
                    },
                }).then(() => {
                    history.push("/login");
                });
            });
        }
    }

    return (
        <div className="w-100 login-recovery">
            <div className="text-center mb-10 mb-lg-20">
                <h3 className="">Alterar senha</h3>
                <p className="text-muted font-weight-bold">
                    Insira a nova senha para fazer a alteração
                </p>
            </div>
            <form
                className="form"
                id="kt_login_recovery_form"
                onSubmit={handleSubmit(handleFormSubmit)}
            >
                <div className="form-group py-3 m-0">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-45 ${
                            formState.errors.Password ? "is-invalid" : ""
                        }`}
                        type="password"
                        placeholder="Nova Senha"
                        name="SenhaNova"
                        autoComplete="off"
                        ref={register({
                            required: "Insira a sua nova senha",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.Password
                            ? formState.errors.Password.message
                            : ""}
                    </div>
                </div>
                <div className="form-group py-3 border-top m-0">
                    <input
                        className={`form-control h-auto border-0 px-0 placeholder-dark-45 ${
                            formState.errors.cPassword ? "is-invalid" : ""
                        }`}
                        type="password"
                        placeholder="Confirmar Senha"
                        name="cPassword"
                        autoComplete="off"
                        ref={register({
                            required: "Insira a sua nova senha novamente",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.cPassword
                            ? formState.errors.cPassword.message
                            : ""}
                    </div>
                </div>
                <div className="form-group d-flex flex-wrap flex-center">
                    <button
                        id="kt_login_recovery_submit"
                        className="btn btn-capys font-weight-bold px-9 py-4 my-3 mx-2"
                    >
                        Alterar Senha
                    </button>
                </div>
            </form>
        </div>
    );
}
